import React from "react";
import { HiXCircle } from "@react-icons/all-files/hi/HiXCircle";
import { HiExclamation } from "@react-icons/all-files/hi/HiExclamation";
import { useTranslation } from "../context/TranslationContext";

const ErrorComp = ({ children, type = "error" }) => {
  const { errorTitle, attention } = useTranslation();
  if (!children) return null;

  const styles = {
    error: {
      container: "bg-red-50 border-red-200",
      iconBg: "text-red-400",
      titleColor: "text-red-800",
      textColor: "text-red-700",
      title: "Hata",
      icon: <HiXCircle className="h-5 w-5" aria-hidden="true" />,
    },
    warning: {
      container: "bg-yellow-50 border-yellow-200",
      iconBg: "text-yellow-400",
      titleColor: "text-yellow-800",
      textColor: "text-yellow-700",
      title: "Uyarı",
      icon: <HiExclamation className="h-5 w-5" aria-hidden="true" />,
    },
  };

  // type prop'u hatalı gelirse varsayılan olarak 'error' kullan
  const activeStyle = styles[type] || styles.error;

  return (
    <div className={`rounded-md p-4 border ${activeStyle.container} mb-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <span className={activeStyle.iconBg}>{activeStyle.icon}</span>
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${activeStyle.titleColor}`}>
            {type === "warning" ? attention : errorTitle}
          </h3>
          <div className={`mt-2 text-sm ${activeStyle.textColor}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComp;
